import { Component, Input, ViewChild } from '@angular/core';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { IOrderDetailsDTO, IPaymentMethod } from '@care-portals/api-interfaces';
import { OrdersFacade } from '../../../+store/orders/orders.facade';
import { AccountFacade } from '../../../+store/account/account.facade';
import { AddStripePaymentMethodComponent } from '../../checkout/add-stripe-payment-method/add-stripe-payment-method.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  selector: 'my-health-order-pay-modal',
  templateUrl: './order-pay-modal.component.html',
  styleUrls: ['./order-pay-modal.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzRadioModule,
    NzModalModule,
    NzButtonModule,
    AddStripePaymentMethodComponent
  ]
})
export class OrderPayModalComponent {
  @Input() order: IOrderDetailsDTO;

  selectedPaymentMethodId = '';
  isAddPaymentMethodVisible = false;
  paymentMethods: IPaymentMethod[];

  @ViewChild(AddStripePaymentMethodComponent, { static: true })
  AddStripePaymentMethodComponent: AddStripePaymentMethodComponent;

  constructor(
    private orderFacade: OrdersFacade,
    private accountFacade: AccountFacade,
    private modal: NzModalRef
  ) {
    this.accountFacade.paymentMethods$.subscribe(paymentMethods => {
      this.paymentMethods = paymentMethods.list;
    });
  }

  onPayClickHandler() {
    if (!this.selectedPaymentMethodId) return;
    this.orderFacade.payInvoiceWithPaymentMethod(
      this.order?.stripe?.invoice?.id,
      this.selectedPaymentMethodId
    );
  }

  cancel() {
    this.modal.close();
  }

  paymentMethodAdded(e) {
    this.hideAddPaymentMethod();
  }

  showAddPaymentMethod() {
    this.isAddPaymentMethodVisible = true;
    // this.AddStripePaymentMethodComponent.onShown();
    this.selectedPaymentMethodId = null;
  }

  hideAddPaymentMethod() {
    this.isAddPaymentMethodVisible = false;
  }

  onPaymentMethodChange() {
    this.hideAddPaymentMethod();
  }
}
